<div class="md-container">
    <h3 class="lb-title-modal">Selecciona tu banco</h3>
    <p-table
        [value]="lsBank"
        [rows]="4"
        styleClass="font-size: 10px; p-datatable-sm;"
        [showCurrentPageReport]="true"
        scrollDirection="both"
        selectionMode="single" 
        [sortField]="'Codigo'"
    >
        <ng-template pTemplate="header" let-columns>
            <tr class="header-table">
            </tr>
            <tr>
                <th scope="col" [hidden]="true">

                </th>
                <th *ngIf="!loading" scope="col">
                    <p-columnfilter 
                        class="filter-modal"
                        type="text" 
                        field="Nombre"
                        placeholder="Buscar banco"
                        matchMode="contains"
                        [showMenu]="false" 
                    ></p-columnfilter>
                </th>
                <p-skeleton *ngIf="loading" height="3rem" styleClass="mb-2 sheleton-header"></p-skeleton>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-dataBank let-rowIndex="rowIndex">
            <tr style="cursor: pointer;" [pSelectableRow]="dataBank" (click)="onRowDblClick($event, dataBank)">
                <td [hidden] = "true">
                    {{dataBank.Id}}
                </td>
                <td>
                    {{dataBank.Nombre}}
                </td>
            </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
            <tr *ngIf="!loading">
                <td colspan="3">No existen registros.</td>
            </tr>
            <p-skeleton *ngIf="loading" height="3rem" styleClass="mb-2"></p-skeleton>
            <p-skeleton *ngIf="loading" height="3rem" styleClass="mb-2"></p-skeleton>
            <p-skeleton *ngIf="loading" height="3rem" styleClass="mb-2"></p-skeleton>
        </ng-template>
    </p-table>
</div>